import { Action } from '@/_core/fluxstore/types';
import { StorymapState } from '../types';
import { useStorymapStore } from '../useModule';
import { BusinessValue } from '../../api/queries';

const { registerReducer } = useStorymapStore();

export class ChangeBusinessValueFilter extends Action<StorymapState> {
    public static ACTION_TYPE = 'ChangeBusinessValueFilter';

    public constructor(public value: BusinessValue) {
        super(ChangeBusinessValueFilter.ACTION_TYPE);
    }
}
const reducer = (state: StorymapState, action: ChangeBusinessValueFilter): void => {
    if (state.filterState.businessValues.includes(action.value)) {
        state.filterState.businessValues = state.filterState.businessValues.filter(x => x != action.value);
    }
    else {
        state.filterState.businessValues.push(action.value);
    }
};

//@ts-ignore
registerReducer(ChangeBusinessValueFilter.ACTION_TYPE, reducer);